module.exports = __webpack_public_path__ + "img/logo.cd7f242b.png";